import { ROLE_LABEL } from "@/components/chat/visitorPatterns";
import { toast } from "sonner";

/** Convert a list of visitor records into a CSV blob and trigger download. */
export function exportVisitorsCsv(rows) {
    if (rows.length === 0) {
        toast.error("No visitors to export with current filters.");
        return;
    }
    const headers = ["Name", "Role", "Messages", "First Seen", "Last Seen", "Session ID", "Notes", "Notes Updated"];
    const escape = (val) => {
        if (val === null || val === undefined) return "";
        const s = String(val).replace(/"/g, '""');
        return /[",\n]/.test(s) ? `"${s}"` : s;
    };
    const lines = [
        headers.join(","),
        ...rows.map((v) =>
            [
                v.name || "",
                v.role ? (ROLE_LABEL[v.role] || v.role) : "",
                v.message_count || 0,
                v.first_seen || "",
                v.last_seen || "",
                v.session_id || "",
                v.notes || "",
                v.notes_updated_at || "",
            ].map(escape).join(",")
        ),
    ];
    const blob = new Blob([lines.join("\n")], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    const today = new Date().toISOString().slice(0, 10);
    a.download = `crossroads-visitors-${today}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
    toast.success(`Exported ${rows.length} visitor${rows.length === 1 ? "" : "s"} to CSV.`);
}
